import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import { Link } from 'wouter';

import { useSite } from '../../contexts/SiteContext';

import styles from '../../styles/headers/banque-nationale-header.module.css';

import banqueNationaleLogo from '../../assets/img/sponsors/banque_nationale_full.svg';
import presentedBy from '../../assets/img/sponsors/banque_nationale_section_presentedby.svg';

interface BanqueNationaleHeaderProps {
    className?: string | null;
}

function BanqueNationaleHeader({ className = null }: BanqueNationaleHeaderProps) {
    const { brands } = useSite();
    const brand = (brands || []).find(({ handle }) => handle === 'quatre95') || null;
    const { sections, slug: brandSlug = null } = brand || {};
    const banqueNationaleSection = (sections || []).find(({ slug }) => slug === 'banque-nationale');
    const { slug: sectionSlug = null } = banqueNationaleSection || {};
    const url = useUrlGenerator();
    return (
        <div className={classNames([styles.container, className])}>
            <Link
                href={url('section', {
                    brand: brandSlug,
                    section: sectionSlug,
                })}
                className={styles.logoContainer}
            >
                <img src={presentedBy} className={styles.presentedBy} alt="Présenté par" />
                <img src={banqueNationaleLogo} className={styles.logo} alt="Banque Nationale" />
            </Link>
        </div>
    );
}

export default BanqueNationaleHeader;
